<mat-card>
  <form [formGroup]="form" (ngSubmit)="save()">
    <mat-card-header>
      <mat-card-title translate="accounts/edition/in-message/email-customization/title"></mat-card-title>
    </mat-card-header>

    <!-- sender email -->
    <mat-form-field appearance="outline" class="shrink">
      <mat-label translate="accounts/edition/in-message/email-customization/sender-email"></mat-label>
      <input type="text" matInput formControlName="defaultSenderEmail" />
      <mat-error
        *ngIf="form.get('defaultSenderEmail').errors?.required"
        translate="common/form_errors/required"></mat-error>
      <mat-error
        *ngIf="form.controls.defaultSenderEmail.errors?.email"
        translate="common/form_errors/invalid-email"></mat-error>
    </mat-form-field>

    <!-- doc link -->
    <div class="not-mat-form-field">
      <a href="https://developers.alcmeon.com/docs/outgoing-email" target="_blank" class="alc-icon-and-name">
        <span translate="accounts/edition/in-message/email-customization/email-doc"></span>
        <mat-icon>launch</mat-icon>
      </a>
    </div>

    <!-- sender name -->
    <mat-form-field appearance="outline" class="shrink">
      <mat-label translate="accounts/edition/in-message/email-customization/sender-name"></mat-label>
      <input type="text" matInput formControlName="defaultSenderName" [maxlength]="restrictions.name.length" />
      <mat-error
        *ngIf="form.get('defaultSenderName').errors?.required"
        translate="common/form_errors/required"></mat-error>
    </mat-form-field>

    <!-- object -->
    <mat-form-field appearance="outline" class="shrink">
      <mat-label translate="accounts/edition/in-message/email-customization/object"></mat-label>
      <input type="text" matInput formControlName="defaultObject" [maxlength]="restrictions.object.length" />
      <mat-error *ngIf="form.get('defaultObject').errors?.required" translate="common/form_errors/required"></mat-error>
    </mat-form-field>

    <!-- toggle header -->
    <div class="not-mat-form-field">
      <mat-slide-toggle color="primary" formControlName="enableHeader">
        <span translate="accounts/edition/in-message/email-customization/header"></span>
      </mat-slide-toggle>
    </div>

    <ng-container *ngIf="form.get('enableHeader').value" formGroupName="header">
      <div class="image-upload">
        <!-- upload header -->
        <div>
          <div>
            <button
              *ngIf="!form.get('header.image').value; else noHeaderImage"
              mat-raised-button
              type="button"
              (click)="clickToLoadHeaderImage()">
              <span translate="accounts/edition/in-message/email-customization/header/upload"></span>
              <span *ngIf="form.get('header.image').hasValidator(validators.required)"> *</span>
            </button>

            <ng-template #noHeaderImage>
              <button mat-raised-button type="button" (click)="removeImage('header')">
                <span translate="accounts/edition/in-message/email-customization/header/remove"></span>
              </button>
            </ng-template>
          </div>
          <input
            #headerFileInput
            type="file"
            accept=".gif,.jpg,.jpeg,.png"
            (change)="loadImage($event, 'header')"
            hidden />
          <div class="not-mat-form-field">
            <mat-hint
              class="specific-hint"
              translate="accounts/edition/in-message/email-customization/img-upload-hint"
              [translateParams]="{
                ext: 'png, jpg, gif',
                width: restrictions.header.image.width,
                height: restrictions.header.image.height,
                weight: restrictions.header.image.weight
              }"></mat-hint>

            <mat-error *ngIf="imagesErrors.header">
              {{ imagesErrors.header }}
            </mat-error>
          </div>
        </div>
        <div>
          <img *ngIf="form.get('header.image').value" [src]="form.get('header.image').value" />
        </div>
      </div>

      <!-- header color -->
      <mat-form-field appearance="outline" class="color shrink">
        <mat-label translate="accounts/edition/in-message/email-customization/header/line-color"></mat-label>
        <input type="color" matInput formControlName="lineColor" />
        <mat-error
          *ngIf="form.get('header.lineColor').errors?.required"
          translate="common/form_errors/required"></mat-error>
      </mat-form-field>
    </ng-container>

    <!-- toggle footer -->
    <div class="not-mat-form-field">
      <mat-slide-toggle color="primary" formControlName="enableFooter">
        <span translate="accounts/edition/in-message/email-customization/footer"></span>
      </mat-slide-toggle>
    </div>

    <ng-container *ngIf="form.get('enableFooter').value" formGroupName="footer">
      <div class="image-upload">
        <!-- upload logo -->
        <div>
          <div>
            <button
              *ngIf="!form.get('footer.image').value; else noHeaderImage"
              mat-raised-button
              type="button"
              (click)="clickToLoadFooterImage()">
              <span translate="accounts/edition/in-message/email-customization/footer/upload"></span>
              <span *ngIf="form.get('footer.image').hasValidator(validators.required)"> *</span>
            </button>

            <ng-template #noHeaderImage>
              <button mat-raised-button type="button" (click)="removeImage('footer')">
                <span translate="accounts/edition/in-message/email-customization/footer/remove"></span>
              </button>
            </ng-template>
          </div>
          <input #logoFileInput type="file" accept=".jpg,.jpeg,.png" (change)="loadImage($event, 'footer')" hidden />
          <div class="not-mat-form-field">
            <mat-hint
              class="specific-hint"
              translate="accounts/edition/in-message/email-customization/img-upload-hint"
              [translateParams]="{
                ext: 'png, jpg, gif',
                width: restrictions.footer.image.width,
                height: restrictions.footer.image.height,
                weight: restrictions.footer.image.weight
              }"></mat-hint>
            <mat-error *ngIf="imagesErrors.footer">
              {{ imagesErrors.footer }}
            </mat-error>
          </div>
        </div>
        <div>
          <img *ngIf="form.get('footer.image').value" [src]="form.get('footer.image').value" />
        </div>
      </div>

      <!-- footer color -->
      <mat-form-field appearance="outline" class="color shrink">
        <mat-label translate="accounts/edition/in-message/email-customization/footer/line-color"></mat-label>
        <input type="color" matInput formControlName="lineColor" />
        <mat-error
          *ngIf="form.get('footer.lineColor').errors?.required"
          translate="common/form_errors/required"></mat-error>
      </mat-form-field>

      <!-- footer text -->
      <mat-form-field appearance="outline" class="shrink footer">
        <mat-label translate="accounts/edition/in-message/email-customization/footer/text"></mat-label>
        <textarea
          #footerText
          type="text"
          matInput
          formControlName="text"
          cdkTextareaAutosize
          cdkAutosizeMinRows="2"
          cdkAutosizeMaxRows="4"
          [maxlength]="restrictions.footer.text.length">
        </textarea>
        <mat-hint
          [innerHTML]="'accounts/edition/in-message/email-customization/footer/text/hint' | translate"></mat-hint>
        <mat-hint align="end">{{ footerText.value.length }} / {{ restrictions.footer.text.length }}</mat-hint>
        <mat-error *ngIf="form.get('footer.text').errors?.required" translate="common/form_errors/required"></mat-error>
      </mat-form-field>
    </ng-container>

    <mat-card-actions>
      <button
        mat-raised-button
        color="primary"
        type="submit"
        translate="accounts/edition/in-message/email-customization/button/publish"
        [disabled]="form.invalid || form.pristine"></button>
      <button mat-raised-button type="button" (click)="cancel()" translate="cancel"></button>
    </mat-card-actions>
  </form>

  <app-card-footer *ngIf="!isCreation" [data]="footerContent"></app-card-footer>
</mat-card>
